import {
    ADD_UNIT, UPDATE_UNIT, DELETE_UNIT,
    PROPERTIES_UNITS_FETCH_INITIAL_DATA, BULK_UPLOAD, DELETE_PROPERTY,
    LOAD_PROPERTIES_UNITS_TENANTS, LOAD_UNITS, LOG_OUT_USER
} from '../../actions/actionTypes';


const addUnitReducer = (units, payload) => {
    let newUnits = { ...units};

    newUnits[payload.unitId] = {
        ...payload
    };
    return newUnits;   
}

const updateUnitReducer = (units, payload) => {
    let newUnits = {...units};
    newUnits[payload.unitId] = { ...payload };
    return newUnits;
}

const deleteUnitReducer = (units, payload) => {
    let newUnits = {...units};
    delete newUnits[payload.unitId];
    return newUnits;
}

const deletePropertyUnitsReducer = (units, payload) => {
    let newUnits = {...units};
    for (const [key, value] of Object.entries(newUnits)) {
        if (value.propertyId == payload.propertyId){
            delete newUnits[value.unitId];
        }
    }
    return newUnits;
}

const loadUnitsReducer = (units, payload) => {
    return {
        ...units,
        ...payload.units,
    };
}


const unitsReducer = (state={}, action) => {
    let  units = state;
    if (action.errors == null){
        switch(action.type){
            case PROPERTIES_UNITS_FETCH_INITIAL_DATA:
                return action.payload.units;
            case ADD_UNIT:
                return addUnitReducer(units, action.payload);
            case UPDATE_UNIT:
                return updateUnitReducer(units, action.payload);
            case DELETE_UNIT:
                return deleteUnitReducer(units, action.payload);
            case DELETE_PROPERTY:
                return deletePropertyUnitsReducer(units, action.payload);
            case LOAD_UNITS:
                return loadUnitsReducer(units, action.payload);
            case LOAD_PROPERTIES_UNITS_TENANTS:
                return action.payload.units;
            case BULK_UPLOAD:
                return action.payload.units;
            case LOG_OUT_USER:
                return {};
            default:
                return units;
        }
    }else{
        return units;
    }
};
export default unitsReducer;